import { render, staticRenderFns } from "./PdpReplacement.vue?vue&type=template&id=14391f2a&"
import script from "./PdpReplacement.vue?vue&type=script&lang=js&"
export * from "./PdpReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports